import ProjectProperties, {ProjectAvailableMenuOptions} from "../project-properties"
import projectProperties_toJSON from "../functions/properties-to-json";
import ProjectSession from "../../project-session";

const DEFAULT = {
    canCreateTask           : false,
    canCreateProject        : true,
    // canCreatePage           : false,
    canCreateLink           : true,
    canCreateEmbed          : true,
    canCreateMeeting        : false,
    canCreateEvent          : false,
    canCreateDiscussion     : false,
    canCreateDocument       : false,
    canCreateGoal           : false,
    canCreateDashboard      : false,
    canCreateRequestForms   : false,
    canCreateAttachments    : false,
    canArchive              : true
}

export default class ProjectWorkspaceProperties extends ProjectProperties {


    private availableColumns : ID[] = [
        'title',
        'check-box',    // table
        'add-cell'    // table
    ]

    constructor(properties:any, project: ProjectSession) {
        super(properties, project)

        this.canCreateTask                      = DEFAULT.canCreateTask
        this.canCreateProject                   = _.get(properties,'canCreateProject', DEFAULT.canCreateProject)
        // this.canCreatePage                      = _.get(properties,'canCreatePage', DEFAULT_VALUES.canCreatePage)
        this.canCreateLink                      = DEFAULT.canCreateLink
        this.canCreateEmbed                     = DEFAULT.canCreateEmbed
        this.canCreateMeeting                   = DEFAULT.canCreateMeeting
        this.canCreateEvent                     = DEFAULT.canCreateEvent
        this.canCreateDiscussion                = DEFAULT.canCreateDiscussion
        this.canCreateDocument                  = DEFAULT.canCreateDocument
        this.canCreateGoal                      = DEFAULT.canCreateGoal
        this.canCreateDashboard                 = DEFAULT.canCreateDashboard
        this.canCreateRequestForms              = DEFAULT.canCreateRequestForms
        this.canCreateAttachments               = DEFAULT.canCreateAttachments
        this.canArchive                         = DEFAULT.canArchive
        this.canHaveStatus                      = false // Workspace can onlky be archived


        this.menuSections.reports               = false
        this.menuSections.integrations          = false
        this.menuSections.automations           = true
        this.menuSections.customers             = false

        // Seettings

        // this.settingsSections.customFields      = false
        // this.settingsSections.taskId            = false
        this.settingsSections.workItems         = false     // fixed - only projects
        this.settingsSections.views             = false     // doesnt have "project" views
        this.settingsSections.navigation        = false


        this.canHaveViews                       = false // workspaces have no views !

    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : false,    // Dumayu tak pravilnee
            info            : true,
            users           : true,
            settings        : true,

            history         : true,
            rename          : true,
            editSource      : false,
            colorIcon       : true,

            move            : false,    // how move ? :)
            convert         : false,    // to what ? :)
            duplicate       : false,    // Eto poka ne rabotaet!!! Nujno li? Nado obsudit!
            saveAsTemplate  : false,    // heponmaytno kak

            status          : false,
            archive         : true,

            delete          : true,
        }
    }

    get handleExpandInsteadOfOpen() {
        return true
    }

    get hasBulkAction() {
        return false
    }

    hasColumn(columnId: string): boolean {

        if (this.availableColumns.includes(columnId)) {
            return true
        }

        return false
    }

    toJSON() {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
